import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProjectData } from '../../pages/Projects/Project';

interface SlideContent {
  title: string;
  description: string;
}

interface ProjectSlide {
  id: number;
  image: string;
  contents: SlideContent[];
}

interface ProjectDetailsState {
  currentStep: number;
  totalSteps: number;
  selectedProject: ProjectData | null;
  projectSlides: ProjectSlide[];
}

const initialState: ProjectDetailsState = {
  currentStep: 1,
  totalSteps: 5,
  selectedProject: null,
  projectSlides: [],
};


const projectDetailsSlice = createSlice({
  name: 'projectDetails',
  initialState,
  reducers: {
    setStep(state, action: PayloadAction<number>) {
      if (action.payload >= 1 && action.payload <= state.totalSteps) {
        state.currentStep = action.payload;
      }
    },
    nextStep(state) {
      if (state.currentStep < state.totalSteps) {
        state.currentStep += 1;
      }
    },
    prevStep(state) {
      if (state.currentStep > 1) {
        state.currentStep -= 1;
      }
    },
    resetSteps(state) {
      state.currentStep = 1;
    },
    setSelectedProject(state, action: PayloadAction<ProjectData>) {
      state.selectedProject = action.payload;
    },
    clearSelectedProject(state) {
      state.selectedProject = null;
      state.projectSlides = [];
    },
    setProjectSlides(state, action: PayloadAction<ProjectSlide[]>) {
      state.projectSlides = action.payload;
    },
  },
});

export const { setStep, nextStep, prevStep, resetSteps, setSelectedProject, clearSelectedProject, setProjectSlides } = projectDetailsSlice.actions;
export default projectDetailsSlice.reducer;
